import { View } from 'dripsy'
import { SpacerProps } from './types'

export default function Spacer(props: SpacerProps) {
  const { x, y, width = x, height = y ?? (width ? undefined : [2, 3]) } = props

  return <View sx={{ pb: height, pr: width, zIndex: -1 }} />
}
